var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"totalBox_view"},[_c('vue-canvas-poster',{attrs:{"borderRadius":"50","painting":_vm.painting},on:{"success":_vm.success,"fail":_vm.fail}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }